import React from 'react';
import './Contact.css';

const Contact: React.FC = () => {
  // Ofuscar datos para evitar spam bots
  const email = 'siorm.drones@gmail.com';
  const phone = '+54 381 418 7185';
  const whatsappNumber = '5493814187185'; // Formato internacional para WhatsApp
  const whatsappUrl = `https://wa.me/${whatsappNumber}`;
  
  return (
    <section id="contact" className="contact">
      <div className="contact-container">
        <h2 className="contact-title">Hablemos de tu Proyecto</h2>
        <p className="contact-subtitle">
          Contáctanos para llevar tus ideas al cielo con tecnología drone
        </p>
        
        <div className="contact-grid">
          {/* Columna Izquierda - Información orientativa */}
          <div className="contact-info-column">
            <h3 className="info-heading">¿Tienes una necesidad específica?</h3>
            <p className="info-description">
              Desarrollamos soluciones personalizadas con drones para resolver lo que necesites.
            </p>
            
            <div className="services-list">
              <div className="service-item">
                <span className="service-icon">▸</span>
                <span className="service-text">Fotografía y Video Aéreo</span>
              </div>
              <div className="service-item">
                <span className="service-icon">▸</span>
                <span className="service-text">Inspecciones Técnicas</span>
              </div>
              <div className="service-item">
                <span className="service-icon">▸</span>
                <span className="service-text">Relevamientos y Topografía</span>
              </div>
              <div className="service-item">
                <span className="service-icon">▸</span>
                <span className="service-text">Producción Audiovisual</span>
              </div>
              <div className="service-item">
                <span className="service-icon">▸</span>
                <span className="service-text">Seguimiento de Obras</span>
              </div>
              <div className="service-item">
                <span className="service-icon">▸</span>
                <span className="service-text">Agricultura de Precisión</span>
              </div>
            </div>
          </div>
          
          {/* Columna Derecha - Contacto directo */}
          <div className="contact-action-column">
            <div className="contact-methods">
              {/* Email */}
              <a href={`mailto:${email}`} className="contact-method">
                <span className="method-icon">✉️</span>
                <span className="method-value">{email}</span>
              </a>
              
              {/* Botones de acción */}
              <div className="contact-buttons">
                <a href={`tel:${phone}`} className="action-btn call-btn">
                  <span className="btn-icon">📞</span>
                  <span className="btn-text">Llamar</span>
                </a>
                <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="action-btn whatsapp-btn">
                  <svg className="btn-icon" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.893 3.488"/>
                  </svg>
                  <span className="btn-text">WhatsApp</span>
                </a>
              </div>
              
              {/* Redes Sociales */}
              <div className="social-links">
          <a 
            href="https://www.instagram.com/siorm.drones.tucuman/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="social-link instagram-link"
            aria-label="Síguenos en Instagram"
          >
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
            </svg>
            <span>Instagram</span>
          </a>
          
          <a 
            href="https://www.youtube.com/@SiormDrones" 
            target="_blank" 
            rel="noopener noreferrer"
            className="social-link youtube-link"
            aria-label="Suscríbete en YouTube"
          >
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
            </svg>
            <span>YouTube</span>
          </a>
        </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
